
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SwitchMock extends Vue {
  state = false
}
